<template>
    <div>
        <v-row>
            <v-col cols="12">
                <span class="t-heading-medium">
                    Módulos
                </span>
            </v-col>
        </v-row>

        <v-row
            v-for="(module, index) in modules"
            :key="index"
            class="align-start"
        >
            <v-col cols="4">
                <v-text-field
                    v-if="readonly"
                    :value="module.module_name"
                    label="Módulo"
                    readonly
                    disabled
                ></v-text-field>
                <cp-select-module
                    v-else
                    v-model="module.module_id"
                    label="Módulo"
                    itemValue="id"
                    :returnObject="true"
                    :persistent="true"
                    :error-messages="getErrorMessages(`modules.${index}.module_id`)"
                    @blur="removeError(`modules.${index}.module_id`)"
                    @change="onModuleSelect(index, module.module_id); removeError(`modules.${index}.module_id`)"
                ></cp-select-module>
            </v-col>

            <v-col cols="3">
                <v-text-field
                    v-model="module.description"
                    label="Descrição"
                    :error-messages="getErrorMessages(`modules.${index}.description`)"
                    :readonly="readonly"
                    :disabled="readonly"
                    @blur="removeError(`modules.${index}.description`)"
                ></v-text-field>
            </v-col>

            <v-col cols="2">
                <v-text-field
                    v-model.number="module.amount"
                    label="Quantidade"
                    type="number"
                    min="1"
                    :error-messages="getErrorMessages(`modules.${index}.amount`)"
                    :readonly="readonly"
                    :disabled="readonly"
                    @blur="removeError(`modules.${index}.amount`)"
                ></v-text-field>
            </v-col>

            <v-col cols="2">
                <cp-input-money
                    v-model.number="module.price"
                    label="Valor"
                    :errors="errors"
                    :errorName="`modules.${index}.price`"
                    :readonly="readonly"
                    :disabled="readonly"
                ></cp-input-money>
            </v-col>

            <v-col cols="1" class="text-right align-self-center">
                <v-btn
                    icon
                    color="error"
                    @click="removeModule(index)"
                    :disabled="readonly || modules.length === 1"
                >
                    <v-icon>$trashCan</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="!readonly">
            <v-col cols="12">
                <v-btn
                    small
                    color="primary"
                    @click="addModule"
                >
                    <v-icon left small>$plus</v-icon>
                    Adicionar módulo
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        modules: {
            type: Array,
            required: true
        },
        errors: {
            type: Object,
            default: null
        },
        availableModules: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        addModule() {
            this.$emit('add-module')
        },

        removeModule(index) {
            this.$emit('remove-module', index)
        },

        onModuleSelect(index, selectedModuleObject) {
            if (selectedModuleObject && typeof selectedModuleObject === 'object') {
                this.modules[index].module_id = selectedModuleObject

                if (selectedModuleObject.price !== undefined && selectedModuleObject.price !== null) {
                    this.modules[index].price = selectedModuleObject.price
                }
            } else {
                this.modules[index].module_id = null
            }
        },

        getErrorMessages(field) {
            return this.errors?.list(field) || []
        },

        removeError(field) {
            this.errors?.remove(field)
        }
    }
}
</script>
